Game.Utils.PlayerPhysics = {

	// jumpMultiplier: 3.3,

	jumpMultiplier: 5.2,

	/**
	 * Run the physics for the specified man.
	 *
	 * @param  {man} man The man to adjust.
	 * @return {null}
	 */
	run: function( man ) {

		// If the man is attached to something then quit.
		//
		// The actual following is done in this.follow, and it should be called
		// in man.postUpdate to ensure things like physics and tweens are
		// completed.
		if ( man.follow ) {
			return;
		}

		if ( !man.alive ) {
			return;
		}

		this.update_direction( man );

		this.check_ladder( man );

		// Run a physics method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {
			this[ 'run_' + man.state ]( man );
		}

	},


	/**
	 * Update the player collision size based upon their current state.
	 */
	update_collision: function( man ) {

		// Width must be no wider than 8 so that the player will fall through small holes.
		var width = 6;

		switch ( man.state ) {

			case Game.Prefabs.Man.states.FLOOR_SLIDE:
			case Game.Prefabs.Man.states.CRAWL:
			case Game.Prefabs.Man.states.DIVE:

				man.body.setSize( width, 8, 4, 7 );

				break;

			case Game.Prefabs.Man.states.CLIMB:

				man.body.setSize( width, 14, 4, 1 );

				break;

			default:

				man.body.setSize( width, 14, 4, 1 );

		}

	},

	can_wall_slide: function( man ) {

		// Offset by the width of a tile so we can be sure we are getting the tile next to the man.
		// Use the man scale to determine direction (since we flip the scale to mirror the animations).
		var x = man.x + ( Game.Utils.Map.TILE_SIZE * man.scale.x );
		// Push the y position towards the middle of the mans body so we can be sure he's near something he can hold on to.
		var y = man.y - 4;

		// Check if the tile the man is clinging on to is collidable.
		if ( Game.Utils.Map.TILE_COLLISION === Game.Utils.Map.get_tile( x, y, Game.Utils.Map.layer_collision ).index ) {

			// Check the man has not touched the floor.
			if ( !man.body.onFloor() ) {
				return true;
			}

		}

		return false;

	},

	head_collide: function( man ) {

		var x = man.x;
		var y = man.y - 15;

		if ( Game.Utils.Map.TILE_COLLISION === Game.Utils.Map.get_tile( x, y, Game.Utils.Map.layer_collision ).index ) {
			return true;
		}

		return false;

	},


	check_ladder: function( man ) {

		// If already climbing then quit.
		if ( Game.Prefabs.Man.states.CLIMB === man.state ) {
			return;
		}

		// If we are flying/ diving and moving fast then lets zoom past the ladder.
		if ( Game.Prefabs.Man.states.FLY || Game.Prefabs.Man.states.DIVE ) {
			if ( Math.abs( man.body.velocity.x ) > 40 ) {
				return;
			}
		}

		// Ladder.
		if ( man.controls.up ) {
			if ( Game.Utils.Map.point_overlap_ladder( man.x, man.y - Game.Utils.Map.TILE_HALF_SIZE ) ) {

				man.state = Game.Prefabs.Man.states.CLIMB;
				Game.Utils.ManagePlatforms.cancelLock( man );

			}
		}

		// If standing on top of a ladder then climb down it.
		if ( man.controls.down ) {
			if ( Game.Utils.Map.point_overlap_ladder( man.x, man.y + Game.Utils.Map.TILE_HALF_SIZE ) ) {

				man.state = Game.Prefabs.Man.states.CLIMB;
				Game.Utils.ManagePlatforms.cancelLock( man );

				man.y += Game.Utils.Map.TILE_SIZE;

			}
		}

	},


	/**
	 * Make the man follow any object that it has been attached to.
	 *
	 * @param  {man} man The man that should follow.
	 */
	follow: function( man ) {

		// Check to see if the man has been parented to anything.
		if ( man.follow ) {

			// Update the position.
			man.x = man.follow.x;
			man.y = man.follow.y;

		}

	},


	/**
	 * Flip the image so that it faces the correct direction.
	 *
	 * By default the images face right, so the default direction is 1. To flip
	 * the direction we set the x scale to -1.
	 */
	update_direction: function( man ) {

		var direction = null;

		// Moving left so flip.
		if ( man.body.velocity.x < -2 ) {

			direction = -1;

		}

		// Moving right so flip.
		if ( man.body.velocity.x > 2 ) {

			direction = 1;

		}

		// Only change the direction if there's enough change in speed.
		if ( direction ) {

			man.scale.x = direction;

		}

	},

	start_jump: function( man ) {

		man.jumpTimer = game.time.time + 300;

	},


	do_jump: function( man ) {

		// Trigger the jumping.
		man.body.jumpHeight = 1;
		man.state = Game.Prefabs.Man.states.JUMP;
		man.body.velocity.y = -20;

		// If on a moving platform then let's add the speed of the platform to the jump.
		if ( man.lockedTo && man.lockedTo.deltaY < 0 ) {
			man.body.velocity.y += man.lockedTo.deltaY * 40;
		}

		// Cancel attachment to platform.
		Game.Utils.ManagePlatforms.cancelLock( man );

		this.update_collision( man );

	},


	/**
	 * Do physics for walking.
	 *
	 * @param  {Object} man [description]
	 */
	run_1: function( man ) {

		Game.Utils.ManagePlatforms.checkLock( man );

		// Default properties.
		var x_speed = 3;

		man.body.velocity.y += 1;
		man.body.velocity.x *= 0.96;

		// Jump.
		// The jumpheight check prevents bouncing when you hold the jump button.
		if ( man.controls.up ) {

			if ( 0 === man.body.jumpHeight ) {

				this.do_jump( man );

			}

		} else {

			man.body.jumpHeight = 0;

		}

		if ( man.controls.down && !man.controls.up ) {

			man.state = Game.Prefabs.Man.states.CRAWL;

			// Traveling fast then let's slide instead!
			if ( Math.abs( man.body.velocity.x ) > 20 ) {

				man.state = Game.Prefabs.Man.states.FLOOR_SLIDE;

			}

			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.start_jump( man );
			this.update_collision( man );

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		}

		if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},


	/**
	 * Flying.
	 *
	 * @param {Object} man [description]
	 */
	run_2: function( man ) {

		// reset velocity.
		var x_speed = 2;
		man.body.velocity.y -= 1;
		man.body.velocity.y *= 0.99;

		// Only apply horizontal friction if the controls are being used.
		// Otherwise friction in the air would look weird.
		if ( man.controls.left || man.controls.right ) {

			man.body.velocity.x *= 0.95;

		} else {

			man.body.velocity.x *= 0.99;

		}

		// Walk.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		} else if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

		if ( !man.controls.up ) {

			man.state = Game.Prefabs.Man.states.FALL;

		}

	},


	/**
	 * Jumping/ Falling.
	 *
	 * @param {Object} man [description]
	 */
	run_3: function( man ) {

		// Default properties.
		var x_speed = 2;

		man.body.velocity.y += 1.5;

		// Only apply horizontal friction if the controls are being used.
		// Otherwise friction in the air would look weird.
		if ( man.controls.left || man.controls.right ) {

			man.body.velocity.x *= 0.95;

		} else {

			man.body.velocity.x *= 0.99;

		}

		// Fly.
		// if ( man.controls.up && ! man.controls.prevUp && game.time.time > man.jumpTimer ) {

		// 	man.state = Game.Prefabs.Man.states.FLY;

		// 	// If the man is falling the slow the descent so that he doesn't
		// 	// use all the fuel not crashing.
		// 	if ( man.body.velocity.y > 0 ) {
		// 		man.body.velocity.y *= 0.25;
		// 	}

		// 	return;

		// }

		// Dive.
		if ( man.controls.down && !man.controls.prevDown ) {

			man.state = Game.Prefabs.Man.states.DIVE;
			man.body.velocity.x *= 5;
			this.update_collision( man );
			return;

		}

		// Jump.
		if ( man.controls.up ) {

			// If character has just started falling and they try to jump then
			// let them.
			if ( game.time.time < man.jumpTimer ) {

				this.do_jump( man );

			}

			/**
			 * Variable height jumping.
			 */
			var jumpLimit = 30;

			if ( man.body.jumpHeight > 0 && man.body.jumpHeight <= jumpLimit ) {

				var y_speed = -this.jumpMultiplier + ( man.body.jumpHeight / ( jumpLimit / this.jumpMultiplier ) );
				man.body.jumpHeight++;
				man.body.velocity.y += y_speed;

			}

			// If we have the rocket pack then allow more jumps.

		} else {

			// Reset jump height so that it no longer processes/
			man.body.jumpHeight = 0;

		}

		if ( man.body.onFloor() ) {

			man.state = Game.Prefabs.Man.states.WALK;

			this.update_collision( man );

			// console.log( man.deltaY );

			if ( man.deltaY > 1.8 ) {

				console.log( 'superhero!' );
				man.state = Game.Prefabs.Man.states.LANDING;
				game.camera.shake( 0.01, 250 );
				man.pause( 750 );
				return;

			}

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		} else if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},


	/**
	 * Dive/ Diving.
	 */
	run_10: function( man ) {

		man.body.velocity.x *= 0.95;
		man.body.velocity.y += 1.5;

		if ( man.body.onFloor() || man.body.onWall() ) {
			man.state = Game.Prefabs.Man.states.FALL;
		}

	},


	/**
	 * Do physics for crawling.
	 *
	 * @param  {Object} man [description]
	 */
	run_4: function( man ) {

		// Default properties.
		var x_speed = 1;

		man.body.velocity.y += 0.6;
		man.body.velocity.x *= 0.95;

		if ( !man.controls.down && !this.head_collide( man ) ) {

			man.state = Game.Prefabs.Man.states.WALK;
			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.update_collision( man );

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		}

		if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},

	run_9: function( man ) {

		// Default properties.
		man.body.velocity.y += 0.6;
		man.body.velocity.x *= 0.99;

		if ( !man.controls.down && !this.head_collide( man ) ) {

			man.state = Game.Prefabs.Man.states.WALK;
			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.update_collision( man );

		}

		// If we slow too much then switch to normal sliding.
		if ( Math.abs( man.body.velocity.x ) < 20 ) {
			man.state = Game.Prefabs.Man.states.CRAWL;
		}

	},


	run_5: function( man ) {

		// Stop all velocities on ladder.
		man.body.velocity.x = 0;
		man.body.velocity.y = 0;

		// Center on the ladder.
		if ( man.controls.up || man.controls.down ) {

			man.x = Game.Utils.Map.tile_coord( man.x ) + Game.Utils.Map.TILE_HALF_SIZE;

		}

		if ( man.controls.up ) {

			man.body.velocity.y = -20;

		}

		if ( man.controls.down ) {

			man.body.velocity.y = 30;

		}

		if ( !man.controls.up && !man.controls.down ) {

			if ( man.controls.left ) {

				man.state = Game.Prefabs.Man.states.JUMP;
				man.body.velocity.x = -20;
				man.body.velocity.y = -35;

			}

			if ( man.controls.right ) {

				man.state = Game.Prefabs.Man.states.JUMP;
				man.body.velocity.x = 20;
				man.body.velocity.y = -35;

			}

		}

		if ( !Game.Utils.Map.point_overlap_ladder( man.x, man.y - Game.Utils.Map.TILE_HALF_SIZE ) ) {

			man.state = Game.Prefabs.Man.states.FALL;
			man.jumpHeight = 9999;

			if ( man.controls.up ) {
				man.body.velocity.y = -20;
			}

		}

	},

	run_6: function( man ) {

		this.run_7( man );

	},

	run_7: function( man ) {

		if ( man.pauseTime < game.time.time ) {

			man.state = Game.Prefabs.Man.states.WALK;

		}

	},


	/**
	 * Wall slide.
	 */
	run_8: function( man ) {

		man.body.velocity.y += 1;
		man.body.velocity.y = man.body.velocity.y * 0.98;

		// Work out which way around the direction controls should be based upon
		// the wall the player is colliding with.
		var slide_control = man.controls.left;
		var jump_control = man.controls.right;

		if ( 1 === man.scale.x ) {
			slide_control = man.controls.right;
			jump_control = man.controls.left;
		}

		// Is the relevant grab direction being pressed (left/ right arrow).
		if ( slide_control ) {
			man.body.velocity.y = man.body.velocity.y * 0.8;
		}

		// Release slide if down key is pressed.
		if ( man.controls.down || man.controls.up ) {
			if ( !slide_control ) {
				man.state = Game.Prefabs.Man.states.FALL;
			}
		}

		// Jumping from a slide involves pressing the opposite direction to the hold.
		if ( jump_control ) {
			man.body.velocity.y = -50;
			man.body.velocity.x = -35 * man.scale.x;
			man.state = Game.Prefabs.Man.states.JUMP;
			this.start_jump( man );
			return;
		}

		// If we can no longer slide then let go and fall.
		if ( !this.can_wall_slide( man ) ) {
			man.state = Game.Prefabs.Man.states.FALL;
		}

	},

};
